import { createSlice } from "@reduxjs/toolkit";

export const workflowCloseSlice = createSlice({
  name: "workflowClose",
  initialState: {
    getWorkflowCloseResult: false,
    getWorkflowCloseLoading: false,
    getWorkflowCloseError: false,
    addWorkflowCloseResult: false,
    addWorkflowCloseLoading: false,
    deleteWorkflowCloseResult: false,
  },
  reducers: {
    workflowCloseReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_WORKFLOWCLOSE":
          return {
            ...state,
            getWorkflowCloseResult: payload.data,
            getWorkflowCloseLoading: payload.loading,
            getWorkflowCloseError: payload.error,
          };
        case "ADD_WORKFLOWCLOSE":
          return {
            ...state,
            addWorkflowCloseResult: payload.data,
            addWorkflowCloseLoading: payload.loading,
          };
        case "DELETE_WORKFLOWCLOSE":
          return {
            ...state,
            deleteWorkflowCloseResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { workflowCloseReducers } = workflowCloseSlice.actions;

export default workflowCloseSlice.reducer;
